<template lang="pug">
  .column.is-11
    data-notification(icon="receipt" v-bind:loading="yields.isLoading" type="is-purple")
      p.title Recebimentos
      p.subtitle {{yields.data}} {{yields.data | pluralize('cadastrado')}} este mês
    article.card.table-card
      header.card-header
        p.card-header-title Recebimentos a Vencer
      .card-content.is-paddingless
        b-table(
          v-bind:data="yieldsDue.data",
          v-bind:striped="true",
          v-bind:narrowed="false",
          v-bind:mobile-cards="false",
          v-bind:loading="yieldsDue.isLoading",
          v-bind:row-class="getRowClass"
        )
          template(slot-scope="props")
            b-table-column(label="Nome") {{props.row.name}}
            b-table-column(label="Valor") {{props.row.value | currency}}
            b-table-column(label="Data") {{props.row.date | moment('DD/MM/YYYY')}}
            b-table-column(label="Status Análise")
              b-tag(v-bind:type="statusClass[props.row.status]") {{ statusLabel[props.row.status] }}
            b-table-column(centered label="Gerenciar" )
              b-tooltip(label="Editar Recebimento" type="is-dark")
                router-link(v-bind:to="{name: 'yieldEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
          template(slot="empty")
            section.section
              .content.has-text-grey.has-text-centered
                p
                  b-icon(icon="sentiment_very_dissatisfied", size="is-large")
                p Nenhum dado.
</template>

<script>
  import DataNotification from './DataNotification'

  import YieldService from '@/services/yield.js'
  const {statusLabel, statusClass} = YieldService

  export default {
    name: 'YieldsDue',
    components: {DataNotification},
    data () {
      return {
        today: this.$moment().startOf('day').toISOString(),
        startOfMonth: this.$moment().startOf('isoMonth').toISOString(),
        yieldsDue: {isLoading: false, data: []},
        yields: {isLoading: false, data: 0},
        statusLabel,
        statusClass
      }
    },
    async created () {
      this.fetchYields()
      this.fetchYieldsDue()
    },
    methods: {
      getRowClass (row) {
        if (row.date <= this.today && row.status !== 'paid') return 'is-danger'
      },
      async fetchYields (params) {
        let query = {created_at: {$gte: this.startOfMonth}, limit: 1}
        query = Object.assign(query, params)
        this.yields.isLoading = true
        const response = await YieldService.query(query)
        this.yields.isLoading = false
        this.yields.data = response.body.meta.count
      },
      async fetchYieldsDue (params) {
        let query = {status: 'provision', limit: 30, sort: {date: 'asc'}}
        query = Object.assign(query, params)
        this.yieldsDue.isLoading = true
        const response = await YieldService.query(query)
        this.yieldsDue.isLoading = false
        this.yieldsDue.data = response.body.yields
      }
    }
  }
</script>

<style lang="sass" scoped>
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// YieldsDue.vue?6023efd2